import type { StateCreator } from 'zustand';
import type { StandardLoanState } from '../standardLoanState';
import type { PropertyForm } from '../../components/Steps/components/Property/constants/propertyForm';

/** The loan's properties: one Property step each for a portfolio loan, and the Property Rollup across them. */
export interface PropertySlice {
    /**
     * The loan's properties, in order; at least one once a loan is loaded (empty before). More than one makes it a
     * portfolio loan (see isPortfolioLoan), which also locks Apprvd Loan Amt (non-Bridge loans) and Origination Fee.
     *
     * TODO (Property step): add/remove/update actions, keeping bfiNumberSuffix equal to each property's position (as
     * EditStdLoanModal does), and carry over EditStdLoanModal's onPropertiesChange / onPropertiesRemove: with more than
     * one property, set Apprvd Loan Amt to the sum of the properties' commitments (not for Bridge loans, which enter it
     * by hand) and Origination Fee to the sum of their origination fees; removing one recalculates both. (Loading a
     * loan already sums the commitments; see getLoanFromLoan.)
     */
    properties: PropertyForm[];
}

/** The Property slice's starting values; reset() puts these back. */
export const initialPropertyState: Pick<PropertySlice, 'properties'> = {
    properties: [],
};

export const createPropertySlice: StateCreator<StandardLoanState, [], [], PropertySlice> = () => ({
    ...initialPropertyState,
});
